import * as React from 'react';

export function Table(props) {
  return (
    <div style={{ display: 'table', width: '100%', tableLayout: 'fixed' }} data-test-id={props?.['data-test-id']}>
      {props.children}
    </div>
  );
}
